import { Model } from 'pinia-orm'
import { Str } from 'pinia-orm/decorators'

export default class Lifeguard extends Model {
    static entity = 'lifeguards'

    @Str('', { notNullable: true })
    declare id: string
    @Str('', { notNullable: true })
    declare firstName: string
    @Str('', { notNullable: true })
    declare lastName: string
    @Str(null)
    declare sex: string
    @Str('', { notNullable: true })
    declare email: string
    @Str('', { notNullable: true })
    declare phone: string
    @Str(null)
    declare regId: string

    get fullName(): string {
        return (this.firstName + ' ' + this.lastName).trim()
    }

    get reverseFullName(): string {
        return (this.lastName + ' ' + this.firstName).trim()
    }

    get fullNameWithIdentification(): string {
        return 'L' + this.id + ' ' + this.fullName
    }

    get reverseFullNameWithIdentification(): string {
        return 'L' + this.id + ' ' + this.reverseFullName
    }

    static piniaOptions = {
        persist: true,
    }
}
